import { AxiosRequestConfig } from "axios";
import api from "../api-instance";
import {
  Client,
  PostClient,
  NewCollaboratorForm,
} from "../../../modules/clients/types";

const ROUTE = "/Clients";

export async function getClients(): Promise<{ data: Client[]; total: number }> {
  // page: number = 1,
  // search: string = "",
  // params?: Partial<Client>,
  // limit: number = 1000
  //TODO: Aplicar parâmetros quando a paginação e ordenação do Back End estiver finalizada

  const config: AxiosRequestConfig = {
    // params: {
    //   _page: page,
    //   _limit: limit,
    //   q: search,
    //   ...params,
    // },
  };

  const result = await api.get<Client[]>(ROUTE, config);
  return {
    data: result.data,
    total: parseInt(result.headers["x-total-count"]),
  };
}
export async function getClient(id: string) {
  const result = await api.get(`${ROUTE}/${id}`);
  return result.data.clientFounded;
  //TODO: remover .clientFounded quando o back end estiver alterado
}
export async function postClient(client: PostClient): Promise<{ id: string }> {
  const result = await api.post(ROUTE, client);
  return result.data;
}

export async function deleteClient(id: string): Promise<{ id: string }> {
  const result = await api.delete(`${ROUTE}/${id}`);
  return result.data;
}

export async function AddCollaborator(
  clientId: string,
  collaborator: NewCollaboratorForm
) {
  const result = await api.patch(
    `${ROUTE}/${clientId}/AddCollaborator`,
    collaborator
  );
  return result.data;
}

export async function addUsina(clientId: string, usinaIds: string[]) {
  const result = await api.patch(`${ROUTE}/${clientId}/GrantAccessToUsina`, {
    usinasIds: usinaIds,
  });
  return result.data;
}

export async function removeUsina(clientId: string, usinaIds: string[]) {
  const result = await api.patch(`${ROUTE}/${clientId}/RemoveAccessToUsina`, {
    usinasIds: usinaIds,
  });
  return result.data;
}

export async function removeCollaborator(
  clientId: string,
  collaboratorEmail: string
) {
  const result = await api.patch(`${ROUTE}/${clientId}/RemoveCollaborator`, {
    email: collaboratorEmail,
  });
  return result.data;
}

export type PathClientDetails = {
  name?: string | null;
  cnpj?: string | null;
  phone?: string | null;
  zipCode?: string | null;
  email?: string | null;
  street?: string | null;
  streetNumber?: string | null;
  complement?: string | null;
  city?: string | null;
  state?: string | null;
};

export async function pathClientDetails(
  clientId: string,
  clientDetails: PathClientDetails
) {
  const result = await api.patch(`${ROUTE}/${clientId}/Details`, clientDetails);
  return result.data;
}
export async function pathClientConnections(
  clientId: string,
  connections: number
) {
  const result = await api.patch(
    `${ROUTE}/${clientId}/simultaneous-connections`,
    {
      connections: connections,
    }
  );
  return result.data;
}

export async function pathAddColaboratorWhatsApp(
  clientId: string,
  collaboratorEmail: string
) {
  const result = await api.patch(
    `${ROUTE}/${clientId}/add-colaborator-whatsapp-enabled`,
    {
      collaboratorEmail: collaboratorEmail,
    }
  );
  return result.data;
}

export async function pathRemoveColaboratorWhatsApp(
  clientId: string,
  collaboratorEmail: string
) {
  const result = await api.patch(
    `${ROUTE}/${clientId}/remove-colaborator-whatsapp-enabled`,
    {
      collaboratorEmail: collaboratorEmail,
    }
  );
  return result.data;
}

export async function pathClientWhatsAppAmount(
  clientId: string,
  amount: number
) {
  const result = await api.patch(
    `${ROUTE}/${clientId}/whatsapp-numbers-amount`,
    {
      amount: amount,
    }
  );
  return result.data;
}
